import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { ITelegramAdminStatsResponse } from './telegram-admin-stats-response';
import { telegramAdminStatsResponseSchema } from './telegram-admin-stats-response';

export async function getTelegramAdminStatsApi(): Promise<
  IValidatedResponse<ITelegramAdminStatsResponse>
> {
  return getRequest<ITelegramAdminStatsResponse>({
    path: '/sys/telegram/stats',
    schema: telegramAdminStatsResponseSchema,
  });
}
